import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextField from 'components/TextField';
import GetAppIcon from '@material-ui/icons/GetApp';
import { StaplesArtFilesProvider } from 'pages/staples-art-files/context';
import StaplesArtFilesDrawer from 'pages/staples-art-files/Tabs';
import { updateReceivedQty } from 'actions/orders';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArtPreviewDialog from 'pages/partn-brigham-and-womens-hosp-program/ImagePreviewModal';
import Button from 'components/Button';
import Datepicker from 'components/DatePicker';
import {
  FieldsWrapper,
  Card,
  Error,
  PrintAreasWrapper,
  PrintAreasHeader,
  PrintAreasFieldsWrapper,
  CloudinaryWrapper,
  ProductFieldWrapper,
  ReceivedQtyFieldsWrapper,
  StaplesShippedDate,
} from 'styles/pages/staples-bulk-orders';

const FormFields = ({
  data,
  handleFieldChange,
  state,
  lineItems,
  deleteLineItem,
}) => {
  const dispatch = useDispatch();
  const [dialogVisibility, setDialogVisibility] = useState(null);
  const [staplesDrawer, setStaplesDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(-1);
  const orderInProduction = state?.status === 'In-Production';

  return (
    <Card
      style={{
        position: 'relative',
        border:
          data?.receivedQuantity === Number(data?.qty)
            ? '2px solid green'
            : 'inherit',
      }}
    >
      {lineItems?.length > 1 && (
        <DeleteIcon
          onClick={deleteLineItem}
          style={{
            color: 'red',
            cursor: 'pointer',
            position: 'absolute',
            right: 5,
            top: 5,
          }}
        />
      )}
      <ProductFieldWrapper>
        <TextField
          size="small"
          label="Product"
          style={{ width: '100%' }}
          value={data?.product}
          onChange={(v) => handleFieldChange('product', v)}
        />

        <TextField
          size="small"
          label="Print Type"
          style={{ width: '100%' }}
          value={data?.printType}
          onChange={(v) => handleFieldChange('printType', v)}
        />
      </ProductFieldWrapper>

      <FieldsWrapper>
        <TextField
          size="small"
          label="Size"
          value={data?.size}
          onChange={(v) => handleFieldChange('size', v)}
        />

        <TextField
          size="small"
          label="Color"
          value={data?.color}
          onChange={(v) => handleFieldChange('color', v)}
        />
        <TextField
          size="small"
          label="Qty"
          value={data?.qty}
          type="number"
          onChange={(v) => handleFieldChange('qty', Number(v))}
        />
      </FieldsWrapper>
      <PrintAreasWrapper>
        <PrintAreasHeader>
          <h3>Print Areas</h3>
          <AddCircleIcon
            onClick={() => {
              handleFieldChange('printAreas', [
                ...data?.printAreas,
                { printAreaName: '', artworkUrl: '' },
              ]);
            }}
          />
        </PrintAreasHeader>

        {data?.printAreas?.map((p, i) => (
          <PrintAreasFieldsWrapper key={`printArea${i}`}>
            <TextField
              size="small"
              label="Name"
              value={p?.printAreaName}
              onChange={(printAreaName) =>
                handleFieldChange(
                  'printAreas',
                  data?.printAreas?.map((q, j) => {
                    if (i !== j) {
                      return q;
                    }

                    return {
                      ...q,
                      printAreaName,
                    };
                  })
                )
              }
            />

            <CloudinaryWrapper>
              {/* {!!p?.artworkUrl && (
                <img
                  src={p?.artworkUrl}
                  alt="artwork"
                  onClick={() => setDialogVisibility(p?.artworkUrl)}
                />
              )} */}
              <TextField
                style={{ width: '100%' }}
                size="small"
                label="Artwork URL"
                value={p?.artworkUrl}
                onChange={(r) =>
                  handleFieldChange(
                    'printAreas',
                    data?.printAreas?.map((q, j) => {
                      if (i !== j) {
                        return q;
                      }

                      return {
                        ...q,
                        artworkUrl: r,
                      };
                    })
                  )
                }
              />
              {/* {orderInProduction ? (
                <GetAppIcon
                  onClick={() => {
                    window.open(p?.artworkUrl);
                  }}
                />
              ) : (
                <CloudUploadIcon
                  onClick={() => {
                    setStaplesDrawer(true);
                    setSelectedRow(i);
                  }}
                />
              )} */}
            </CloudinaryWrapper>

            {i > 0 && (
              <DeleteIcon
                onClick={() => {
                  handleFieldChange(
                    'printAreas',
                    data?.printAreas?.filter((p, j) => i !== j)
                  );
                }}
              />
            )}
          </PrintAreasFieldsWrapper>
        ))}
      </PrintAreasWrapper>

      {state.status === 'In-Production' && (
        <PrintAreasWrapper>
          <PrintAreasHeader>
            <h3>Received Quantity</h3>
          </PrintAreasHeader>

          <ReceivedQtyFieldsWrapper>
            <TextField
              size="small"
              label="Received Quantity"
              value={data?.receivedQuantity}
              type="number"
              onChange={(v) => handleFieldChange('receivedQuantity', Number(v))}
            />

            <Button
              title="Save"
              disabled={!data?.receivedQuantity}
              onClick={async () => {
                await dispatch(
                  updateReceivedQty({
                    po: Number(state?.orderPdfData?.orderPO[0]),
                    lineItems,
                  })
                );
              }}
            />
          </ReceivedQtyFieldsWrapper>
        </PrintAreasWrapper>
      )}

      {(!data?.color ||
        !data?.size ||
        !data?.product ||
        data?.color === data?.size ||
        !data.qty) && <Error>Please check Line Item data carefully!</Error>}

      {!!dialogVisibility && (
        <ArtPreviewDialog
          open={!!dialogVisibility}
          setOpen={() => setDialogVisibility(false)}
          artworkUrl={dialogVisibility}
        />
      )}
      <StaplesArtFilesProvider>
        <StaplesArtFilesDrawer
          isDrawer={true}
          searchDefaultValue={state?.orderPdfData?.ID}
          drawerVisibility={staplesDrawer}
          onClose={() => {
            setStaplesDrawer(false);
            setSelectedRow(-1);
          }}
          onSelect={(r) => {
            handleFieldChange(
              'printAreas',
              data?.printAreas?.map((q, j) => {
                if (selectedRow !== j) {
                  return q;
                }
                return {
                  ...q,
                  artworkUrl: r?.secure_url,
                };
              })
            );
            setSelectedRow(-1);
            setStaplesDrawer(false);
          }}
          deleteArtFile={false}
        />
      </StaplesArtFilesProvider>
    </Card>
  );
};

export default FormFields;
